import { useDeleteSchemeIssue } from "http-hooks/schIssue/useSchemeIssue";
import DeleteConfirmation from "components/ui/DeleteConfirmation";

export default function DeleteSchemeIssue({ id, onClose }) {
  const { mutateAsync, isPending } = useDeleteSchemeIssue();

  const handleDelete = async () => {
    try {
      await mutateAsync(id);
      onClose();
    } catch (error) {
      // Error toast already shown by service
      console.error("Delete failed:", error);
    }
  };

  return (
    <DeleteConfirmation
      title="Delete Scheme Issue"
      description="Are you sure you want to delete this scheme issue? This record will be permanently removed. This action cannot be undone."
      onDelete={handleDelete}
      onClose={onClose}
      isLoading={isPending}
    />
  );
}
